// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1270":"d02c4374","2767":"c2d49989","3319":"18e4e6af","3831":"f1f7d885","4144":"aa952b21","8775":"b714b368"}[chunkId] + ".chunk.css";
};